export default {
    baseStyle: {
        containerStyles: {
            padding: {
                base: '0 16px',
                sm: '0 32px',
                lg: '0 64px'
            },
            maxWidth: {
                base: '100%',
                lg: '1920px'
            },
            margin: '0 auto'
        }
    },
    parts: ['containerStyles']
}
